import React, { useRef } from "react";
import IcoContact from "../svg/IcoContact";
import IcoSearch from "../svg/IcoSearch";
import { useLocation, useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const isOnArticle = location?.pathname?.startsWith("/p/");
  const timerRef = useRef(null);

  const doSearch = (value, replace = false) => {
    const term = value.trim();
    if (term === "") {
      navigate("/", { replace });
    } else {
      navigate(`/?search=${encodeURIComponent(term)}`, { replace });
    }
  };

  const handleChange = e => {
    const value = e.target.value;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => doSearch(value, true), 500);
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      if (timerRef.current) clearTimeout(timerRef.current);
      doSearch(e.target.value);
    }
  };

  return (
    <div>
      <div className="bg-primaryLight md:px-16 px-2.5 py-2.5 flex-col sm:flex-row gap-y-2.5 text-white gap-x-5 text-sm leading-5 flex items-center justify-between">
        <div className="text-center pb-2.5 border-b border-b-primary sm:text-left sm:pb-0 sm:border-none">
          Le spécialiste des solutions d&apos;accès pour les professionnels
        </div>
        <div className="flex items-center gap-x-2.5">
          <div className="h-4 w-4 text-white">
            <IcoContact />
          </div>
          <div>
            Contactez-nous au <b>03.25.71.98.26</b>
          </div>
        </div>
      </div>
      <div
        className="flex gap-x-5 items-center justify-between md:px-16 px-5 py-6 bg-center bg-cover bg-no-repeat"
        style={{ backgroundImage: "url('/bkg-prodistri.jpg')" }}
      >
        <a href="/" className="sm:w-36 sm:h-20 h-10 w-14">
          <img
            className="w-full h-full object-contain"
            src="/prodistribution-logo.png"
            alt="Logo pro distribution automatismes"
          />
        </a>

        <div className="flex-1 max-w-[540px] relative">
          <input
            className={`w-full p-3 rounded-3 ${isOnArticle ? "pr-12" : ""}`}
            type="text"
            name="search"
            id="search"
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            placeholder="Rechercher un produit, une référence ou une marque..."
            aria-label="Champ de recherche"
          />
          {isOnArticle && (
            <button
              type="button"
              className="absolute right-1 top-1/2 -translate-y-1/2 h-9 w-9 flex items-center justify-center rounded-3 bg-primary text-white hover:bg-primaryLight transition-colors"
              aria-label="Rechercher"
              onClick={() => {
                const term = document.getElementById("search")?.value?.trim();
                if (term) navigate(`/?search=${encodeURIComponent(term)}`);
              }}
            >
              <div className="h-4 w-4">
                <IcoSearch />
              </div>
            </button>
          )}
        </div>

        <div className="w-36 hidden lg:block"></div>
      </div>
    </div>
  );
}
